module.exports = __webpack_public_path__ + "img/chinesecompany12.13d25d2d.png";